import React from "react";
import config from "lib/fr-config";
import TXT from "presentational/common/multinational/TXT";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const fontCss = config.css.fontThickness;

// const FREE_TRIAL_PERIOD = config.membership.freeTrial.duration;

const FAQQuestionTypography = withStyles({
  root: {
    fontSize: 20,
    paddingBottom: 5,
    fontWeight: fontCss.bold
  }
})(Typography);
const FAQAnswerTypography = withStyles({
  root: {
    fontSize: 16,
    paddingLeft: 20,
    paddingBottom: 30
  }
})(Typography);

function FAQInfoSectionView(props) {
  return (
    <div>
      {/* <FAQQuestionTypography>
        <TXT name="msg_faqQuestion1" />
      </FAQQuestionTypography>
      <FAQAnswerTypography>
        <TXT name="msg_faqAnswer1" />
      </FAQAnswerTypography>
      <FAQQuestionTypography>
        <TXT name="msg_faqQuestion2" />
      </FAQQuestionTypography>
      <FAQAnswerTypography>
        <TXT name="msg_faqAnswer2" input={{ duration: FREE_TRIAL_PERIOD }} />
      </FAQAnswerTypography> */}
      <FAQQuestionTypography>
        <TXT name="msg_faqQuestion3" />
      </FAQQuestionTypography>
      <FAQAnswerTypography>
        <TXT name="msg_faqAnswer3" />
      </FAQAnswerTypography>
      <FAQQuestionTypography>
        <TXT name="msg_faqQuestion4" />
      </FAQQuestionTypography>
      <FAQAnswerTypography>
        <TXT name="msg_faqAnswer4" />
      </FAQAnswerTypography>
    </div>
  );
}

export default FAQInfoSectionView;
